"use client";

import { isServer } from "@tanstack/react-query";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export interface PositionsDrawerSettings {
  show: boolean;
  ratio: number;
  currentHeight: number;
}

export const positionsDrawerSettingsAtom =
  atomWithStorage<PositionsDrawerSettings>(
    "positionsDrawerSettings",
    {
      show: true,
      ratio: 1,
      currentHeight: isServer ? 300 : window.innerHeight / 4,
    },
    undefined,
    { getOnInit: true },
  );

export const updatePositionsDrawerSettingsAtom = atom(
  null,
  (get, set, updates: Partial<PositionsDrawerSettings>) => {
    const current = get(positionsDrawerSettingsAtom);
    set(positionsDrawerSettingsAtom, {
      ...current,
      ...updates,
    });
  },
);

export const usePositionsDrawerSettings = () => {
  const positionsDrawerSettings = useAtomValue(positionsDrawerSettingsAtom);
  const setPositionsDrawerSettings = useSetAtom(
    updatePositionsDrawerSettingsAtom,
  );

  return {
    positionsDrawerSettings,
    setPositionsDrawerSettings,
  };
};
